import { CarouselItem } from '@/components/ui/carousel'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Label } from '@/components/ui/label'
import { useTranslation } from 'react-i18next'
import { useNeedsAnalysis } from '@/contexts/needs-analysis/NeedsAnalysisContext'
import type { CommunicationFrequencyPreference } from '@/types/learner-portal'
import { COMMUNICATION_FREQUENCIES } from '@/constants/needsAnalysis'

export default function CommunicationFrequencyScreen() {
  const { t } = useTranslation()
  const { communication_frequency, setCommunicationFrequency } = useNeedsAnalysis()

  return (
    <CarouselItem className='px-2 sm:px-8'>
      <div className='space-y-2 py-2 sm:space-y-6 sm:py-6'>
        <div className='space-y-1 sm:space-y-2'>
          <h3 id='communication-frequency-heading' className='text-base font-medium text-gray-900 sm:text-xl'>
            {t('needsAnalysis.communicationFrequency.title')}
          </h3>
        </div>

        <RadioGroup
          aria-labelledby='communication-frequency-heading'
          value={communication_frequency || undefined}
          onValueChange={(val) => setCommunicationFrequency(val as CommunicationFrequencyPreference)}
          className='space-y-2 sm:space-y-3'
        >
          {COMMUNICATION_FREQUENCIES.map((frequency) => (
            <Label
              key={frequency}
              htmlFor={`frequency-${frequency}`}
              className='flex cursor-pointer items-center space-x-2 rounded-lg border border-gray-200 p-2 transition-colors hover:bg-gray-50 sm:space-x-3 sm:p-4'
            >
              <RadioGroupItem value={frequency} id={`frequency-${frequency}`} />
              <span className='flex-1 text-sm font-medium sm:text-base'>
                {t(`needsAnalysis.communicationFrequency.options.${frequency}`)}
              </span>
            </Label>
          ))}
        </RadioGroup>
      </div>
    </CarouselItem>
  )
}
